export const GET_LABOR_SHED = "GET_LABOR_SHED";
export const SET_LOADING = "SET_LOADING";
export const DASHBOARD_ERROR = "DASHBOARD ERROR";
export const RESET_DASHBOARD = "RESET_DASHBOARD";
